module.exports = __webpack_public_path__ + "img/Clip.aab52c60.svg";